import { render, staticRenderFns } from "./Tomap2.vue?vue&type=template&id=2bf5fc54&scoped=true&"
import script from "./Tomap2.vue?vue&type=script&lang=js&"
export * from "./Tomap2.vue?vue&type=script&lang=js&"
import style0 from "./Tomap2.vue?vue&type=style&index=0&id=2bf5fc54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5fc54",
  null
  
)

export default component.exports